// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"b8b5ffb9","333":"49868f41","343":"22d56e56","593":"d03a526e","722":"d370d441","879":"76df88fb","939":"342353dd"}[chunkId] + ".chunk.js";
};